import { render } from "./textarea.vue?vue&type=template&id=c5fa4144"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5fa4144"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5fa4144', __exports__)) {
    console.log('reload')
    api.reload('c5fa4144', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=c5fa4144", () => {
    console.log('re-render')
    api.rerender('c5fa4144', render)
  })

}


export default __exports__